import { z } from "zod";

import { ERROR_TYPE } from "@/utils";

const { REQUIRED } = ERROR_TYPE;

export const IndustrySchema = z.object({
	id: z.number().optional(),
	name: z.string().min(1, { message: REQUIRED }),
});

export const CreateIndustrySchema = z.object({
	name: z.string().min(1, { message: REQUIRED }),
});

export const UpdateIndustrySchema = z.object({
	id: z.number(),
	name: z.string().min(1, { message: REQUIRED }),
});

export const DeleteIndustrySchema = z.object({
	id: z.number(),
});

export const IndustryArraySchema = z.array(IndustrySchema);

export type Industry = z.infer<typeof IndustrySchema>;
export type CreateIndustry = z.infer<typeof CreateIndustrySchema>;
export type UpdateIndustry = z.infer<typeof UpdateIndustrySchema>;
export type DeleteIndustry = z.infer<typeof DeleteIndustrySchema>;
export type IndustryArray = z.infer<typeof IndustryArraySchema>;
